import {PAWebSocketClient} from "../PA.Core/PAWebSocketClient";

import {
    IPlanningService,
    IPlanningServiceApproveEventsOptions,
    IPlanningServiceApproveEventsResults,
    IPlanningServiceCalculateApprovalsOptions,
    IPlanningServiceCalculateApprovalsResults,
    IPlanningServiceCalculateEventOptions,
    IPlanningServiceCalculateEventResults,
    IPlanningServiceCalculatePlanOptions,
    IPlanningServiceCalculatePlanResults,
    IPlanningServiceGetBaselineDataOptions,
    IPlanningServiceGetBaselineDataResults,
    IPlanningServiceGetPricingEngineDataOptions,
    IPlanningServiceGetPricingEngineDataResults,
    IPlanningServiceMoveEventsStatusOptions,
    IPlanningServiceMoveEventsStatusResults,
    IPlanningServiceRefreshBaselineOptions,
    IPlanningServiceRefreshBaselineResults,
    IPlanningServiceSummaryDataOptions,
    IPlanningServiceSummaryDataResults,
    IPlanningServiceSumOfPartsOptions,
    IPlanningServiceSumOfPartsResults
} from "./PA.TPM.Services.IF";


export enum PlanningServiceRequestType {
    GetBaseLineData,
    GetPricingEngineData,
    GetSummaryData,
    CalculatePlan,
    CalculateEvent,
    CalculateApprovals,
    ApproveEvents,
    GetSumOfParts,
    MoveEventStatus,
    RefreshBaseline
}

export interface IPlanningServiceRequest {
    RequestType: PlanningServiceRequestType,
    RequestOptions: any
}

export class PlanningService
    implements IPlanningService {

    private static wsc: PAWebSocketClient;

    constructor() {
        PlanningService.wsc = new PAWebSocketClient();
    }

    getBaselineData(opts: IPlanningServiceGetBaselineDataOptions): Promise<IPlanningServiceGetBaselineDataResults> {
        return PlanningService.staticGetBaselineData(opts)
    }

    getPricingEngineData(opts: IPlanningServiceGetPricingEngineDataOptions): Promise<IPlanningServiceGetPricingEngineDataResults> {
        return PlanningService.staticGetPricingEngineData(opts);
    }

    calculatePlan(opts: IPlanningServiceCalculatePlanOptions): Promise<IPlanningServiceCalculatePlanResults> {
        return PlanningService.staticCalculatePlan(opts);
    }

    calculateEvent(opts: IPlanningServiceCalculateEventOptions): Promise<IPlanningServiceCalculateEventResults> {
        return PlanningService.staticCalculateEvent(opts);
    }

    calculateApprovals(opts: IPlanningServiceCalculateApprovalsOptions) : Promise<IPlanningServiceCalculateApprovalsResults> {
        return PlanningService.staticCalculateApprovals(opts);
    }

    getSummaryData(opts: IPlanningServiceSummaryDataOptions) : Promise<IPlanningServiceSummaryDataResults> {
        return PlanningService.staticGetSummaryData(opts);
    }

    approveEvents(opts: IPlanningServiceApproveEventsOptions): Promise<IPlanningServiceApproveEventsResults> {
        return PlanningService.staticApproveEvents(opts);
    }

    getSumOfPartsData(opts: IPlanningServiceSumOfPartsOptions): Promise<IPlanningServiceSumOfPartsResults> {
        return PlanningService.staticGetSumOfPartsData(opts);
    }

    moveEventStatus(opts: IPlanningServiceMoveEventsStatusOptions): Promise<IPlanningServiceMoveEventsStatusResults>{
        return PlanningService.staticMoveEventStatus(opts)
    }

    refreshBaseline(opts: IPlanningServiceRefreshBaselineOptions): Promise<IPlanningServiceRefreshBaselineResults> {
        return PlanningService.staticRefreshBaseline(opts);
    }

    private static staticGetBaselineData(opts: IPlanningServiceGetBaselineDataOptions): Promise<IPlanningServiceGetBaselineDataResults> {
        return new Promise<IPlanningServiceGetBaselineDataResults>((resolve, error) => {
            let aRequest: IPlanningServiceRequest = {
                RequestType: PlanningServiceRequestType.GetBaseLineData,
                RequestOptions: opts
            }
            PlanningService.processRequest(aRequest)
                .then((results) => {
                    // Vaidate Results..?
                    resolve(results)
                })
                .catch((err) => {
                    error(err)
                })
        });

    }

    private static staticGetPricingEngineData(opts: IPlanningServiceGetPricingEngineDataOptions): Promise<IPlanningServiceGetPricingEngineDataResults> {

        return new Promise<IPlanningServiceGetPricingEngineDataResults>((resolve, error) => {
            let aRequest: IPlanningServiceRequest = {
                RequestType: PlanningServiceRequestType.GetPricingEngineData,
                RequestOptions: opts
            }
            PlanningService.processRequest(aRequest)
                .then((results) => {
                    // Vaidate Results..?
                    resolve(results)
                })
                .catch((err) => {
                    error(err)
                })
        });

    }

    private static staticCalculatePlan(opts: IPlanningServiceCalculatePlanOptions): Promise<IPlanningServiceCalculatePlanResults> {

        return new Promise<IPlanningServiceCalculateEventResults>((resolve, error) => {
            let aRequest: IPlanningServiceRequest = {
                RequestType: PlanningServiceRequestType.CalculatePlan,
                RequestOptions: opts
            };
            PlanningService.processRequest(aRequest)
                .then((results) => {
                    // Vaidate Results..?
                    resolve(results)
                })
                .catch((err) => {
                    error(err)
                })
        });

    }

    private static staticGetSummaryData(opts: IPlanningServiceSummaryDataOptions) : Promise<IPlanningServiceSummaryDataResults> {
        return new Promise<IPlanningServiceSummaryDataResults>((resolve, error) => {
            let aRequest: IPlanningServiceRequest = {
                RequestType: PlanningServiceRequestType.GetSummaryData,
                RequestOptions: opts
            };
            PlanningService.processRequest(aRequest)
                .then((results) => {
                    resolve(results)
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

    private static staticCalculateEvent(opts: IPlanningServiceCalculateEventOptions): Promise<IPlanningServiceCalculateEventResults> {

        return new Promise<IPlanningServiceCalculateEventResults>((resolve, error) => {
            let aRequest: IPlanningServiceRequest = {
                RequestType: PlanningServiceRequestType.CalculateEvent,
                RequestOptions: opts
            }
            PlanningService.processRequest(aRequest)
                .then((results) => {
                    // Vaidate Results..?
                    resolve(results)
                })
                .catch((err) => {
                    error(err)
                })
        });

    }

    private static staticCalculateApprovals(opts: IPlanningServiceCalculateApprovalsOptions): Promise<IPlanningServiceCalculateApprovalsResults> {

        return new Promise<IPlanningServiceCalculateApprovalsResults>((resolve, error) => {
            let aRequest: IPlanningServiceRequest = {
                RequestType: PlanningServiceRequestType.CalculateApprovals,
                RequestOptions: opts
            };

            PlanningService.processRequest(aRequest)
                .then((results) => {
                    resolve(results);
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

    private static staticApproveEvents(opts: IPlanningServiceApproveEventsOptions): Promise<IPlanningServiceApproveEventsResults> {
        return new Promise<IPlanningServiceApproveEventsResults>((resolve, error) => {
            let aRequest: IPlanningServiceRequest = {
                RequestType: PlanningServiceRequestType.ApproveEvents,
                RequestOptions: opts
            };

            PlanningService.processRequest(aRequest)
                .then((results) => {
                    resolve(results);
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

    private static staticGetSumOfPartsData(opts: IPlanningServiceSumOfPartsOptions) : Promise<IPlanningServiceSumOfPartsResults> {
        return new Promise<IPlanningServiceSumOfPartsResults>((resolve, error) => {
            let aRequest: IPlanningServiceRequest = {
                RequestType: PlanningServiceRequestType.GetSumOfParts,
                RequestOptions: opts
            };

            PlanningService.processRequest(aRequest)
                .then((results) => {
                    resolve(results);
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

    private static staticMoveEventStatus(opts: IPlanningServiceMoveEventsStatusOptions): Promise<IPlanningServiceMoveEventsStatusResults> {
        return new Promise<IPlanningServiceMoveEventsStatusResults>((resolve, error) => {
            let aRequest: IPlanningServiceRequest = {
                RequestType: PlanningServiceRequestType.MoveEventStatus,
                RequestOptions: opts
            };

            PlanningService.processRequest(aRequest)
                .then((results) => {
                    resolve(results);
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

    private static staticRefreshBaseline(opts: IPlanningServiceRefreshBaselineOptions): Promise<IPlanningServiceRefreshBaselineResults> {
        return new Promise<IPlanningServiceRefreshBaselineResults>((resolve, reject) => {
            const aRequest: IPlanningServiceRequest = {
                RequestType: PlanningServiceRequestType.RefreshBaseline,
                RequestOptions: opts
            };
            PlanningService.processRequest(aRequest)
                .then((result) => {
                    resolve(result);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // request is send to server-lb/boot/PAPlanningService, and passed to server-pa/**/PlanningService
    private static async processRequest(aRequest: IPlanningServiceRequest): Promise<any> {

        let results: any;

        try {
            results = await PlanningService.wsc.invoke('PlanningService', aRequest, {ackTimeout: 60*1000*30});
        } catch (err) {
            results = {};
            results.bSuccess = false;
            results.sErrors = [err.message];
        }

        return results;
    }

}